import React, { useState, useContext } from 'react';
import Header from '../headerAdmin/Header';
import { UserTypeContext } from '../../AppRoute';
import Footer from '../adminFooter/Footer';
import './Layout.css';

const Layout = ({ children, ...headerProps }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { userType } = useContext(UserTypeContext);

  // Callback to receive drawer state from Header
  const handleDrawerStateChange = (drawerOpen) => {
    setIsDrawerOpen(drawerOpen);
  };

  // Determine if drawer should be shown
  const shouldShowDrawer = headerProps?.poweResumeAvialable === undefined && userType !== "Candidate" && userType !== "Admin";

  const layoutDrawerClass = shouldShowDrawer ? (isDrawerOpen ? 'drawer-open' : 'drawer-closed') : 'no-drawer';

  return (
    <div className={`layout-container ${layoutDrawerClass}`}>
      <Header
        {...headerProps}
        onDrawerStateChange={handleDrawerStateChange}
      />
      <main className={`main-content ${shouldShowDrawer
          ? (isDrawerOpen ? 'drawer-open' : 'drawer-closed')
          : 'no-drawer'
        }`}>
        <div className={`page-wrapper ${userType === "Admin" ? "admin" : ""}`}>
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
